<app-bread-crumb></app-bread-crumb>
<div class="form">
  <app-news-info [FunctionID]="this.newsres.FunctionID"></app-news-info>
</div>
